export const satInfoBoxOrbitalConfigurationDefaults = {
    enabled: true,
    isShowCovariance: true,
};
